import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import * as S from './InclusionWrap.styles';

import {reviewStaticInclusionsSelector} from '@ibibo/hotels-review-reducer';
import Modal, {useModal} from '../../../../../shared/components/Modal';
import BrandModalHeader from '../../../../../shared/components/BrandModalHeader';
import RoundedCheckboxIcon from '../../../../Icons/RoundedCheckbox';

import FreeCancelTickIcon  from '../../../../Icons/FreeCancelTick';

const InclusionWrap = ({freeCancellationDate, extraMessages, hotelsPolicy, cancellationPolicy}) => {
  const inclusions = useSelector(reviewStaticInclusionsSelector);
  const initialListSizeLimit = 3;
  const [sizeLimit, setSizeLimit] = useState(initialListSizeLimit);
  const {isModalOpen, openModal, closeModal} = useModal();

  return (
    <S.InclusionWrapOuterDiv>
      {(!!freeCancellationDate && (
        <S.FreeCancelOuterDiv>
          <S.FreeCanelTickImgWrap>
            <FreeCancelTickIcon width="1.3rem" height="1.8rem" />
          </S.FreeCanelTickImgWrap>
          <S.FreeCancelTxtSpan>Free cancellation, {freeCancellationDate} 
            <S.FreeCancelDateInfoText>&nbsp;(
              <S.CancelPolicyLink
                  onClick={() => {
                    openModal();
                  }}
                >
                 Booking and Cancellation Policy
                </S.CancelPolicyLink>
            ) </S.FreeCancelDateInfoText>
          </S.FreeCancelTxtSpan>
        </S.FreeCancelOuterDiv>
      )) || <S.NonRefundableDiv>Non-refundable <S.CancelPolicyLink
      onClick={() => {
        openModal();
      }}
    >
      &nbsp; Booking and Cancellation Policy
    </S.CancelPolicyLink></S.NonRefundableDiv>}

      <S.AmenitiesOuterWrap>
        {(Array.isArray(inclusions) && inclusions.length && (
          <>
            {inclusions.slice(0, sizeLimit).map((item, index) => (
              <S.TypeofAminitiesDiv>
                <S.TickDiv></S.TickDiv>
                <S.TypeofAminitiestxtSpan>
                  {item}

                  {inclusions.length > sizeLimit && index + 1 == sizeLimit && (
                    <S.ViewAllLink
                      onClick={() => {
                        setSizeLimit(inclusions.length);
                      }}
                    >
                      + View All
                    </S.ViewAllLink>
                  )}
                </S.TypeofAminitiestxtSpan>
              </S.TypeofAminitiesDiv>
            ))}
          </>
        )) ||
      null}
      </S.AmenitiesOuterWrap>
      

      {extraMessages &&
        extraMessages.map(({text, txtcolor}) => (
          <S.TypeofAminitiesDiv>
            <S.TypeofAminitiestxtSpan color={txtcolor}>{text}</S.TypeofAminitiestxtSpan>
          </S.TypeofAminitiesDiv>
        ))}
      

      <Modal isOpen={isModalOpen} closeModal={closeModal} modalStyles={{width: 'auto'}}>
        {((!!cancellationPolicy.length || !!hotelsPolicy.length) && (
          <S.PolicyContentContainer>
            {!!cancellationPolicy.length && (
              <>
                <BrandModalHeader>Cancellation Policy</BrandModalHeader>

                <S.CancellationPolicyList>
                  {cancellationPolicy.map(item => (
                    <S.CancellationPolicyListItem key={item}>
                      <RoundedCheckboxIcon />
                      <S.CancellationItemText>{item}</S.CancellationItemText>
                    </S.CancellationPolicyListItem>
                  ))}
                </S.CancellationPolicyList>
              </>
            )}
            {!!hotelsPolicy.length && (
              <>
                <BrandModalHeader>Hotel Policy</BrandModalHeader>

                <S.CancellationPolicyList>
                  {hotelsPolicy.map(item => (
                    <S.CancellationPolicyListItem key={item}>
                      <RoundedCheckboxIcon />
                      <S.CancellationItemText>{item}</S.CancellationItemText>
                    </S.CancellationPolicyListItem>
                  ))}
                </S.CancellationPolicyList>
              </>
            )}
          </S.PolicyContentContainer>
        )) || (
          <>
            <S.CancellationPolicyLoaderContainer>
              <S.CancellationPolicyListLoaderSmallItem></S.CancellationPolicyListLoaderSmallItem>
              <S.CancellationPolicyListLoaderLargeItem></S.CancellationPolicyListLoaderLargeItem>
              <S.CancellationPolicyListLoaderSmallItem></S.CancellationPolicyListLoaderSmallItem>
              <S.CancellationPolicyListLoaderLargeItem></S.CancellationPolicyListLoaderLargeItem>
            </S.CancellationPolicyLoaderContainer>
          </>
        )}
      </Modal>
    </S.InclusionWrapOuterDiv>
  );
};

export default InclusionWrap;
